import { useEffect, useState } from "react";

import { getEnabledTab } from "app/pages/activation/helpers/settings/getEnabledTab";
import { proNavigator } from "single-spa/react-app/ProNavigator";

type UseTabsParams = {
    tabs?: string[];
    disabledTabs?: number[];
    isLoading?: boolean;
};

export const useTabs = ({ tabs = [], disabledTabs, isLoading = false }: UseTabsParams = {}) => {
    const { tab = "0", ...restParams } = proNavigator.getParams();
    const currentName = proNavigator.current().name;
    const enabledTab = getEnabledTab(+tab, tabs, disabledTabs);

    const [tabIndex, setTabIndex] = useState(enabledTab);

    useEffect(() => {
        if (isLoading) {
            return;
        }

        if (+tab !== enabledTab) {
            proNavigator.updateParams({ tab: enabledTab }, { location: "replace" });
        }

        setTabIndex(enabledTab);
    }, [enabledTab, tab, isLoading]);

    const onTabSelect = (nextTab: number) => {
        const currentUrl = proNavigator.href(currentName, { ...restParams, tab: nextTab });

        window.history.replaceState(null, "", currentUrl);
        setTabIndex(nextTab);
    };

    return { tabIndex, onTabSelect };
};
